import React, { Component } from 'react';
import Button from '@components/atoms/button/Button';

export class SocialAuthButton extends Component {
  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
    if (this.popup && !this.popup.closed) this.popup.close();
  }

  getUrl = () => {
    const { redirectUri, clientId, scope, isRegister } = this.props;
    const supportIE = false;

    const state = 'fdsf78fyds7fm';
    // registerNewAccount;
    //ADSK
    const adskAuthenLink = `${FE_URL}/adsk_redirect${
      isRegister ? '?register=true' : ''
    }`;
    const adskRedirectPath = `${FE_URL}/adsk_redirect`;

    //GOOGLE
    const googleAuthenLink = `${API_URL}/login-external/google`;
    const googleRedirectPath = `${FE_URL}/google?redirect_uri=${encodeURIComponent(
      googleAuthenLink
    )}`;

    //Apple
    const appleAuthenLink = `${API_URL}/login-external/apple`;
    const appleRedirectPath = `${FE_URL}/apple?redirect_uri=${encodeURIComponent(
      appleAuthenLink
    )}`;

    const getProviderConfig = () => {
      switch (this.props.provider) {
        case 'adsk':
          return {
            authLink: adskAuthenLink,
            redirectPath: adskRedirectPath,
          };

        case 'google':
          return {
            authLink: googleAuthenLink,
            redirectPath: googleRedirectPath,
          };

        case 'apple':
          return {
            authLink: appleAuthenLink,
            redirectPath: appleRedirectPath,
          };

        default:
          break;
      }
    };
    const authLink = getProviderConfig().authLink;
    const redirectPath = getProviderConfig().redirectPath;

    if (supportIE) {
      const redirectLink = `${window.location.origin}${redirectPath}`;
      return redirectLink;
    }
    return authLink;
  };

  receiveMessage = event => {
    const { state } = 'fdsf78fyds7fm';
    if (event.origin === window.location.origin) {
      if (event.data.errorMessage && event.data.from === this.props.provider) {
        // Prevent CSRF attack by testing state

        if (event.data.state !== state) {
          this.popup && this.popup.close();
          return;
        }
        this.props.onFailure(event.data.errorMessage);
        this.popup && this.popup.close();
      } else if (event.data.code && event.data.from === this.props.provider) {
        // Prevent CSRF attack by testing state

        if (event.data.state !== state) {
          this.popup && this.popup.close();
          return;
        }

        this.props.onSuccess({ token: event.data.code });
        this.popup && this.popup.close();
      }
    }
  };
  openPopup = ({ url, title, w, h }) => {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `
      scrollbars=no,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
    );
    window.removeEventListener('message', this.receiveMessage, false);
    window.addEventListener('message', this.receiveMessage, false);

    if (window.focus) newWindow.focus();
  };

  handleOnClick = e => {
    if (e) {
      e.preventDefault();
    }

    this.props.onClick && this.props.onClick();

    this.openPopup({ url: this.getUrl(), title: 'Login', w: 600, h: 600 });
  };

  render() {
    const { disabled, renderElement, label } = this.props;
    if (renderElement) {
      return renderElement({
        onClick: this.handleOnClick,
        disabled,
      });
    }
    return (
      <Button
        type="normal"
        label={label}
        colorTheme={this.props.provider}
        svgIcon={this.props.provider}
        actionType="onclick"
        onClick={this.handleOnClick}
        css={{ marginBottom: '$8', width: '100%' }}
      />
    );
  }
}

export default SocialAuthButton;
